export default "__VITE_ASSET__nPTiw4tq__"